import { LogLevel, log } from "../utils/log";
import { EventHandler } from "./registerEventHandler";
import { GameEvent } from "../interfaces/theos.interface";
import { postToOperator } from "./postToOperator";
import { processOutbound } from "./messageProcessor";

type Listener = EventHandler<{readonly type: GameEvent; readonly payload?: {}}>;

const outboundMessageListeners: Listener[] = [];

// TODO: save commands and send later if operator is not yet listening?
export const sendGameEvent = (type: GameEvent, payload?: {}): void =>
{
    outboundMessageListeners.forEach((handler) => {
        handler({type, payload});
    });

    const message = processOutbound(type, payload);

    if (message !== undefined) {
        log("Sending 🠊", LogLevel.ALL_MESSAGES, message);
        postToOperator(message);
    }
};

/**
 * Listen to the events sent by the game.
 * The callback will receive all the events.
 */
export const registerOutBoundMessagesListener = (listener: Listener): void =>
{
    outboundMessageListeners.push(listener);
};